import React, { Component } from 'react';
import '../styles/NavMenu.css';
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import { Link } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { NavItem } from 'react-bootstrap';
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    NavbarText
} from 'reactstrap';
import Search from './Home/Search';
import Background from '../img/banner.jpeg';
import { appService } from '../_services';
import { JournalsComponent } from './Journals/JournalsComponent';
import { AllEncyclopedias } from './Encyclopedias/AllEncyclopedias';
import { AllManuals } from './Manuals/AllManuals';
import { authHeader, config } from '../_helpers'
import { Redirect, Route } from 'react-router-dom';

var sectionStyle = {
    backgroundImage: "url(" + Background + ")"
};

var Activeclass = {
    backgroundColor: '#0058A1',
    padding: '0.5rem 2rem'
}
var Paddingset = {
    padding: '0.5rem 2rem'
}

var Setpadd = {
    paddingLeft: '0px',
    color: '#000'
    // padding:'1px 0px'
}
var Setmorepad = {
    // padding: '2px 0px'
}


export class NavMenu extends Component {
    constructor(props) {
        super(props);

        this.Searchchild = React.createRef();
        this.state = {
            bgHomeColor: "",
            bgJournalColor: "",
            bgManualColor: "",
            bgEncycloColor: "",
            bgTopicColor: "",
            NavHide: true,
            authorName: "",
            IsFromJournal: false,
            isFromEncyclo: false,
            IsFromManual: false,
            Logout: false,
            redirectToLogin: false,

        }
        this.logoutsession = this.logoutsession.bind(this);
        this.handleLeavePage = this.handleLeavePage.bind(this);
        this.ToggleButtonClick = this.ToggleButtonClick.bind(this);

    }


    componentWillUnmount() {

        window.removeEventListener('beforeunload', this.handleLeavePage);
    }

    //handleLeavePage(e) {
    //    debugger;
    //    if (localStorage.getItem('user') !== null) {

    //        appService.getAll('/User/logOut').then(function (response) {

    //            localStorage.removeItem('user');
    //            localStorage.removeItem('userId');
    //            localStorage.removeItem('usersubscription');
    //            localStorage.removeItem('company');
    //            localStorage.removeItem('firstName');
    //            localStorage.removeItem('lastName');
    //            localStorage.setItem('logoutclick', 'true');

    //        });
    //        window['LastURL'] = '';
    //    }
    //}
    // console.log(window['LastURL']);

    handleLeavePage(e) {

        if (localStorage.getItem('user') !== null) {

            //  this.logoutsession();
            //debugger;
            //appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {

            //    localStorage.removeItem('user');
            //    localStorage.removeItem('userId');
            //    localStorage.removeItem('usersubscription');
            //    localStorage.removeItem('company');
            //    localStorage.removeItem('firstName');
            //    localStorage.removeItem('lastName');
            //    localStorage.setItem('logoutclick', 'true');

            //});
            //window['LastURL'] = '';
        }
    }

    // console.log(window['LastURL']);

    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');
                    self.setState({
                        redirectToLogin: true
                    })
                });
                window['LastURL'] = '';
            });

        }
        self.loginClick();
    }

    ToggleButtonClick() {

        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse") {
            element.classList.value = "navbar-collapse collapse show";
        }
        else {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler") {
                toggleele[i].classList.value = "navbar-toggler collapsed";
            }
        }

        var toggle = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggle.length; i++) {
            if (toggle[i].classList.value == "navbar-toggler collapsed") {
                toggle[i].classList.value = "navbar-toggler";
            }
        }


    }

    FirstClick = (e) => {

        this.setState({
            bgHomeColor: "#0058A1",
            bgJournalColor: "",
            bgManualColor: "",
            bgEncycloColor: "",
            bgTopicColor: "",
            NavHide: true,
        })

        this.Searchchild.current.HideSaarchonClick("");

        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }

    }

    SecondClick = (e) => {
        this.setState({
            bgHomeColor: "",
            bgJournalColor: "#0058A1",
            bgManualColor: "",
            bgEncycloColor: "",
            bgTopicColor: "",

        })
        if (document.location.pathname.split('/')[1] == "AllJournals") {
            this.Searchchild.current.HideSaarchonClick("All journals");
        }
        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }
    }

    ThirdClick = (e) => {
        this.setState({
            bgHomeColor: "",
            bgManualColor: "#0058A1",
            bgJournalColor: "",
            bgEncycloColor: "",
            bgTopicColor: "",

        })
        this.Searchchild.current.HideSaarchonClick("All manuals");
        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }
    }

    FourthClick = (e) => {
        this.setState({
            bgHomeColor: "",
            bgEncycloColor: "#0058A1",
            bgJournalColor: "",
            bgManualColor: "",
            bgTopicColor: "",

        })
        this.Searchchild.current.HideSaarchonClick("All encyclopaedias");
        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }
    }

    FifthClick = (e) => {
        this.setState({
            bgHomeColor: "",
            bgTopicColor: "#0058A1",
            bgJournalColor: "",
            bgManualColor: "",
            bgEncycloColor: "",

        })
        this.Searchchild.current.HideSaarchonClick("");
        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }
    }

    loginClick() {
        var element = document.getElementById("responsive-navbar-nav");
        if (element.classList.value == "navbar-collapse collapse show") {
            element.classList.value = "navbar-collapse collapse";
        }

        var toggleele = document.getElementsByClassName("navbar-toggler collapsed");
        for (var i = 0; i < toggleele.length; i++) {
            if (toggleele[i].classList.value == "navbar-toggler collapsed") {
                toggleele[i].classList.value = "navbar-toggler";
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            authorName: nextProps.AuthorName
        });

        if (document.location.pathname == "/AboutSubscription"
            || document.location.pathname == "/AdvisoryBoard"
            || document.location.pathname == "/ContactSales"
            || document.location.pathname == "/ContentDelivery"
            || document.location.pathname == "/OurContent"
            || document.location.pathname == "/StaticContent/OurContent"
            || document.location.pathname == "/StaticContent/ContentDelivery"
            || document.location.pathname == "/StaticContent/AdvisoryBoard"
            || document.location.pathname == "/ThankyouSubscription"
            || document.location.pathname == "/Etoc"
            || document.location.pathname == "/ManageEtoc"
            || document.location.pathname == "/ManageAccount"
            || document.location.pathname == "/Feedback"
            || document.location.pathname == "/Maintenance"
            || document.location.pathname == "/SearchResult") {

            this.setState({
                bgHomeColor: "",
                bgEncycloColor: "",
                bgJournalColor: "",
                bgManualColor: "",
                bgTopicColor: "",

            })

        }
        if (document.location.pathname == "/" || document.location.pathname == "/LoginHome") {
            this.FirstClick
        }
        if (document.location.pathname.split('/')[1] == "AllJournals"
            || document.location.pathname.split('/')[1] == "Journals"
            || document.location.pathname.split('/')[1] == "journalissue"
            || document.location.pathname.split('/')[1] == "journalarticle") {
            this.SecondClick
        }
        if (document.location.pathname.split('/')[1] == "AllEncyclopedias"
            || document.location.pathname.split('/')[1] == "Encyclopedias"
            || document.location.pathname.split('/')[1] == "EncyclopediaChapter") {
            this.FourthClick
        }
        if (document.location.pathname.split('/')[1] == "AllManuals"
            || document.location.pathname.split('/')[1] == "Manuals"
            || document.location.pathname.split('/')[1] == "ManualChapter") {
            this.ThirdClick
        }

        if (document.location.pathname == "/PracticeAreas" || document.location.pathname == "/PracticeArea") {
            this.FifthClick
        }

    }

    componentDidUpdate() {

        var elm = document.getElementById("HomeLink");
        var elm1 = document.getElementById("JournalLink");
        var elm2 = document.getElementById("EncyLink");
        var elm3 = document.getElementById("ManualLink");
        var elm4 = document.getElementById("TopicLink");

        if (document.location.pathname == "/" || document.location.pathname == "/LoginHome") {
            elm.style.backgroundColor = "#0058A1";
            // elm.style.border = "1px solid #0058A1";
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
        }

        if (document.location.pathname.split('/')[1] == "AllJournals") {

            elm1.style.backgroundColor = "#0058A1";
            // elm1.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;

            this.Searchchild.current.HideSaarchonClick("All journals");
        }

        if (document.location.pathname.split('/')[1] == "JournalIssue") {
            elm1.style.backgroundColor = "#0058A1";
            // elm1.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("JournalIssue");
        }

        if (document.location.pathname.split('/')[1] == "Journals") {
            elm1.style.backgroundColor = "#0058A1";
            //elm1.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("JournalPublication");
        }

        if (document.location.pathname.split('/')[1] == "journalarticle") {
            elm1.style.backgroundColor = "#0058A1";
            //elm1.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("journalarticle");
        }

        if (document.location.pathname.split('/')[1] == "AllEncyclopedias") {
            elm2.style.backgroundColor = "#0058A1";
            // elm2.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("All encyclopaedias");
        }

        if (document.location.pathname.split('/')[1] == "Encyclopedias") {
            elm2.style.backgroundColor = "#0058A1";
            //  elm2.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("Encyclopedias");
        }

        if (document.location.pathname.split('/')[1] == "EncyclopediaChapter") {
            elm2.style.backgroundColor = "#0058A1";
            //  elm2.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("EncyclopediaChapter");
        }

        if (document.location.pathname.split('/')[1] == "AllManuals") {
            elm3.style.backgroundColor = "#0058A1";
            //  elm3.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("All manuals");
        }

        if (document.location.pathname.split('/')[1] == "Manuals") {
            elm3.style.backgroundColor = "#0058A1";
            //  elm3.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("Manuals");
        }

        if (document.location.pathname.split('/')[1] == "ManualChapter") {
            elm3.style.backgroundColor = "#0058A1";
            //  elm3.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm4.style.backgroundColor = null;
            elm4.style.border = null;
            this.Searchchild.current.HideSaarchonClick("ManualChapter");
        }

        if (document.location.pathname == "/PracticeArea") {
            elm4.style.backgroundColor = "#0058A1";
            // elm4.style.border = "1px solid #0058A1";
            elm.style.backgroundColor = null;
            elm.style.border = null;
            elm1.style.backgroundColor = null;
            elm1.style.border = null;
            elm2.style.backgroundColor = null;
            elm2.style.border = null;
            elm3.style.backgroundColor = null;
            elm3.style.border = null;
            this.Searchchild.current.HideSaarchonClick("");
        }

        if (document.location.pathname == "/Subscription") {
            if (this.Searchchild.current !== null) {
                this.Searchchild.current.HideSaarchonClick("Your subscriptions");
            }
        }

        if (document.location.pathname == "/" || document.location.pathname == "/AboutSubscription"
            || document.location.pathname == "/AdvisoryBoard"
            || document.location.pathname == "/ContactSales"
            || document.location.pathname == "/ContentDelivery"
            || document.location.pathname == "/OurContent"
            || document.location.pathname == "/StaticContent/OurContent"
            || document.location.pathname == "/StaticContent/ContentDelivery"
            || document.location.pathname == "/StaticContent/AdvisoryBoard"
            || document.location.pathname == "/ThankyouSubscription"
            || document.location.pathname == "/Etoc"
            || document.location.pathname == "/ManageEtoc"
            || document.location.pathname == "/ManageAccount"
            || document.location.pathname == "/Feedback"
            || document.location.pathname == "/Maintenance") {
            if (this.Searchchild.current !== null) {
                this.Searchchild.current.HideSaarchonClick("");
            }
        }

        if (document.location.pathname == "/SearchResult") {
            if (this.Searchchild.current !== null) {
                this.Searchchild.current.HideSaarchonClick("SearchResult");
            }
        }
    }

    componentDidMount() {

        window.addEventListener('beforeunload', this.handleLeavePage);
        if (document.location.pathname.split('/')[1] == "" || document.location.pathname.split('/')[1] == "LoginHome") {
            window.addEventListener('load', this.FirstClick)
        }
        if (document.location.pathname.split('/')[1] == "AllJournals"
            || document.location.pathname.split('/')[1] == "Journals"
            || document.location.pathname.split('/')[1] == "journalissue"
            || document.location.pathname.split('/')[1] == "journalarticle") {
            window.addEventListener('load', this.SecondClick)
        }
        if (document.location.pathname.split('/')[1] == "AllEncyclopedias"
            || document.location.pathname.split('/')[1] == "Encyclopedias"
            || document.location.pathname.split('/')[1] == "EncyclopediaChapter") {
            window.addEventListener('load', this.FourthClick)
        }
        if (document.location.pathname.split('/')[1] == "AllManuals"
            || document.location.pathname.split('/')[1] == "Manuals"
            || document.location.pathname.split('/')[1] == "ManualChapter") {
            window.addEventListener('load', this.ThirdClick)
        }

        if (document.location.pathname == "/PracticeAreas" || document.location.pathname == "/PracticeArea") {
            window.addEventListener('load', this.FifthClick)
        }

        if (document.location.pathname.split('/')[1] == "AllJournals") {
            this.Searchchild.current.HideSaarchonClick("All journals");
        }

        if (document.location.pathname.split('/')[1] == "JournalIssue") {
            this.Searchchild.current.HideSaarchonClick("JournalIssue");
        }

        if (document.location.pathname.split('/')[1] == "Journals") {
            this.Searchchild.current.HideSaarchonClick("JournalPublication");
        }

        if (document.location.pathname.split('/')[1] == "journalarticle") {
            this.Searchchild.current.HideSaarchonClick("journalarticle");
        }

        if (document.location.pathname.split('/')[1] == "AllEncyclopedias") {
            this.Searchchild.current.HideSaarchonClick("All encyclopaedias");
        }

        if (document.location.pathname.split('/')[1] == "Encyclopedias") {
            this.Searchchild.current.HideSaarchonClick("Encyclopedias");
        }

        if (document.location.pathname.split('/')[1] == "EncyclopediaChapter") {
            this.Searchchild.current.HideSaarchonClick("EncyclopediaChapter");
        }

        if (document.location.pathname.split('/')[1] == "AllManuals") {
            this.Searchchild.current.HideSaarchonClick("All manuals");
        }

        if (document.location.pathname.split('/')[1] == "Manuals") {
            this.Searchchild.current.HideSaarchonClick("Manuals");
        }

        if (document.location.pathname.split('/')[1] == "ManualChapter") {
            this.Searchchild.current.HideSaarchonClick("ManualChapter");
        }


        if (document.location.pathname == "/PracticeArea") {
            this.Searchchild.current.HideSaarchonClick("");
        }

        if (document.location.pathname == "/Subscription") {
            if (this.Searchchild.current !== null) {
                this.Searchchild.current.HideSaarchonClick("Your subscriptions");
            }
        }

        if (window.location.pathname == "/ShoppingCart" || window.location.pathname == "/LoginShoppingCart") {
            this.setState({
                NavHide: false,
            })
        }

        var self = this;
        appService.getAll('Home/GetMktCampaignData')
            .then(function (textdata) {
                self.setState({ marketingText: textdata });
            });

    }

    updateParent(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch) {
        this.props.headerCallback(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch);
    }



    displayName = NavMenu.name


    handleResponse(response) {
        return new Promise((resolve, reject) => {
            if (response.ok) {
                // return json if it was returned in the response
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.includes("application/json")) {
                    response.json().then(json => resolve(json));
                } else {
                    resolve();
                }
            } else {
                // return error message from response body
                response.text().then(text => reject(text));
            }
        });
    }

    handleError(error) {
        return Promise.reject(error && error.message);
    }

    stingBreakLine(str, length, ending) {
        //console.log(str.length);
        if (length == null) {
            length = 20;
        }
        if (ending == null) {
            ending = '..';
        }

        if (str != null && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        if (window.location.pathname !== "/Login") {
            window['LastURL'] = window.location.pathname;
        }

        return (
            <div>
                {this.state.NavHide ?
                    <Navbar collapseOnSelect expand="lg" className="navbar-default" id="MyNav">
                        <button aria-controls="responsive-navbar-nav" onClick={this.ToggleButtonClick} type="button" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggler-icon"></span></button>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto col-lg-10 Navbluewidth" style={{ backgroundColor: '#007AC3' }}>
                                <NavItem className="">
                                    <Link id="HomeLink" className="nav-link" to={(localStorage.getItem('user') !== null) ? "/LoginHome" : "/"} style={this.state.bgHomeColor == "#0058A1" && window.location.pathname !== "/SearchContent" ? Activeclass : Paddingset} onClick={this.FirstClick}>Home</Link>
                                </NavItem>
                                {(() => {
                                    if (document.location.pathname != "/Login" && document.location.pathname !== "/ForgotPassword" && document.location.pathname !== "/ChangePassword" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <NavItem>
                                                <Link id="JournalLink" className=" nav-link" to={'/AllJournals'} style={this.state.bgJournalColor == "#0058A1" && window.location.pathname !== "/SearchContent" ? Activeclass : Paddingset} onClick={this.SecondClick}>Journals</Link>
                                            </NavItem>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (document.location.pathname !== "/Login" && document.location.pathname !== "/ForgotPassword" && document.location.pathname !== "/ChangePassword" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <NavItem>
                                                <Link id="EncyLink" className=" nav-link" to={'/AllEncyclopedias'} style={this.state.bgEncycloColor == "#0058A1" && window.location.pathname !== "/SearchContent" ? Activeclass : Paddingset} onClick={this.FourthClick}>Encyclopaedias</Link>
                                            </NavItem>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (document.location.pathname !== "/Login" && document.location.pathname !== "/ForgotPassword" && document.location.pathname !== "/ChangePassword" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <NavItem>
                                                <Link id="ManualLink" className=" nav-link" to={'/AllManuals'} style={this.state.bgManualColor == "#0058A1" && window.location.pathname !== "/SearchContent" ? Activeclass : Paddingset} onClick={this.ThirdClick}>Manuals</Link>
                                            </NavItem>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (document.location.pathname !== "/Login" && document.location.pathname !== "/ForgotPassword" && document.location.pathname !== "/ChangePassword" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <NavItem>
                                                <Link id="TopicLink" className=" nav-link" to={'/PracticeAreas'} style={this.state.bgTopicColor == "#0058A1" && window.location.pathname !== "/SearchContent" ? Activeclass : Paddingset} onClick={this.FifthClick}>Practice areas</Link>
                                            </NavItem>
                                        )
                                    }
                                })()}
                                {(() => {
                                    if (document.location.pathname == "/Login" || document.location.pathname == "/ForgotPassword" && document.location.pathname !== "/ChangePassword" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <NavItem>
                                                <Link className=" nav-link" to={'/Login'} style={Activeclass} onClick={this.loginClick}>Login</Link>
                                            </NavItem>
                                        )
                                    }
                                })()}
                            </Nav>
                            {
                                localStorage.getItem('user') !== null && document.location.pathname !== "/Login" ?
                                    <Nav className="activeLogin col-lg-2 NavGreenWidth" onClick={() => this.setState({ Logout: !this.state.Logout })} style={Setpadd}>

                                        <UncontrolledDropdown style={{ position: 'initial' }} className="Uncontrolledmargin">
                                            <DropdownToggle nav caret>
                                                {
                                                    localStorage.getItem('company') !== "null" && localStorage.getItem('company') !== null && localStorage.getItem('company') !== '' ?
                                                        localStorage.getItem('company').length < 20 ?
                                                            localStorage.getItem('company')
                                                            :
                                                            this.stingBreakLine(localStorage.getItem('company'), 20, '..')
                                                        :
                                                        (localStorage.getItem('firstName') == '' && localStorage.getItem('lastName') == '')
                                                            || (localStorage.getItem('firstName') == 'null' && localStorage.getItem('lastName') == 'null') ?
                                                            localStorage.getItem('user').length < 20 ?
                                                                localStorage.getItem('user').replace("\"", "").replace("\"", "")
                                                                :
                                                                this.stingBreakLine(localStorage.getItem('user').replace("\"", "").replace("\"", ""), 20, '..')
                                                            :
                                                            localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName')

                                                }
                                                {this.state.Logout ?
                                                    <img alt="" src=" /../../images/arrow_up.png" style={{ paddingLeft: '10px', color: '#000' }} />
                                                    :
                                                    <img alt="" src=" /../../images/arrow_down.png" style={{ paddingLeft: '10px', color: '#000' }} />
                                                }
                                            </DropdownToggle>

                                            <DropdownMenu style={{ backgroundColor: '#80C342', border: '0px', minWidth: '336px', marginTop: '0px', backgroundClip: 'inherit', textAlign: 'center' }}>
                                                <DropdownItem style={{ backgroundColor: '#80C342', color: '#FFFFFF' }}>
                                                    <span className="HoverUnderline">

                                                        <Link to="/ManageAccount" onClick={this.loginClick}> Manage my Personal account</Link>

                                                    </span>
                                                </DropdownItem>
                                                <DropdownItem style={{ backgroundColor: '#80C342', color: '#FFFFFF' }}>
                                                    <span className="HoverUnderline" onClick={this.logoutsession}> Logout</span>
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>

                                    </Nav>
                                    :
                                    <Nav className="activeLogin col-lg-2 NavGreenWidth">
                                        <NavItem className="removeback">
                                            <img alt="" src=" /../../images/login.png" style={{ paddingRight: '10px' }} />
                                            <Link className=" nav-link HoverUnderline" to={'/Login'} style={{ display: 'inline-block', color: '#000' }} onClick={this.loginClick}>Login</Link>
                                        </NavItem>
                                    </Nav>
                            }

                        </Navbar.Collapse>
                    </Navbar>

                    :
                    null}

                {!this.state.NavHide ?
                    <Navbar collapseOnSelect expand="lg" className="navbar-default" id="MyNav">
                        <button aria-controls="responsive-navbar-nav" onClick={this.ToggleButtonClick} type="button" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggler-icon"></span></button>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto col-lg-10 Navbluewidth" style={{ backgroundColor: '#007AC3' }}>
                                <NavItem className="">
                                    <Link className=" nav-link" to={(localStorage.getItem('user') !== null) ? "/LoginHome" : "/"} style={{ backgroundColor: this.state.bgHomeColor }} onClick={this.FirstClick}>
                                        <span>
                                            <i style={{ fontSize: '20px', paddingRight: '10px', color: 'white' }} className="fa fa-angle-left"></i>
                                        </span>
                                        Back to Kluwer Law Online
                                        </Link>
                                </NavItem>
                            </Nav>
                            {
                                localStorage.getItem('user') !== null && document.location.pathname !== "/Login" ?
                                    <Nav className="activeLogin col-lg-2 NavGreenWidth" onClick={() => this.setState({ Logout: !this.state.Logout })} style={Setpadd}>

                                        <UncontrolledDropdown style={{ position: 'initial' }} className="Uncontrolledmargin">
                                            <DropdownToggle nav caret>
                                                {
                                                    localStorage.getItem('company') !== "null" && localStorage.getItem('company') !== null && localStorage.getItem('company') !== '' ?
                                                        localStorage.getItem('company').length < 20 ?
                                                            localStorage.getItem('company')
                                                            :
                                                            this.stingBreakLine(localStorage.getItem('company'), 20, '..')
                                                        :
                                                        (localStorage.getItem('firstName') == 'null' && localStorage.getItem('lastName') == 'null')
                                                            || (localStorage.getItem('firstName') == '' && localStorage.getItem('lastName') == '') ?
                                                            localStorage.getItem('user').length < 20 ?
                                                                localStorage.getItem('user').replace("\"", "").replace("\"", "")
                                                                :
                                                                this.stingBreakLine(localStorage.getItem('user').replace("\"", "").replace("\"", ""), 20, '..')
                                                            :
                                                            localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastName')
                                                }
                                                {this.state.Logout ?
                                                    <img alt="" src=" /../../images/arrow_up.png" style={{ paddingLeft: '10px', color: '#000' }} />
                                                    :
                                                    <img alt="" src=" /../../images/arrow_down.png" style={{ paddingLeft: '10px', color: '#000' }} />
                                                }
                                            </DropdownToggle>

                                            <DropdownMenu style={{ backgroundColor: '#80C342', border: '0px', minWidth: '336px', marginTop: '0px', backgroundClip: 'inherit', textAlign: 'center' }}>

                                                <DropdownItem style={{ backgroundColor: '#80C342', color: '#FFFFFF' }}>
                                                    <span className="HoverUnderline">
                                                        <Link to="/ManageAccount" onClick={this.loginClick}> Manage my Personal account</Link>
                                                    </span>
                                                </DropdownItem>
                                                <DropdownItem style={{ backgroundColor: '#80C342', color: '#FFFFFF' }}>
                                                    <span className="HoverUnderline" onClick={this.logoutsession}> Logout</span>
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>

                                    </Nav>
                                    :
                                    <Nav className="activeLogin col-lg-2 NavGreenWidth">
                                        <NavItem className="removeback">
                                            <img alt="" src=" /../../images/login.png" style={{ paddingRight: '10px' }} />
                                            <Link className="nav-link HoverUnderline" to={'/Login'} style={{ display: 'inline-block', color: '#000' }} onClick={this.loginClick}>Login</Link>
                                        </NavItem>
                                    </Nav>
                            }
                        </Navbar.Collapse>
                    </Navbar>

                    :
                    null}
                <div>

                    {this.state.NavHide ?
                        <div>
                            <div style={document.location.pathname == "/" ? sectionStyle : null} className={document.location.pathname == "/" ? "SetBgHomeImg" : "SearchBg"}>
                                {(() => {
                                    if (document.location.pathname !== "/ForgotPassword" && document.location.pathname !== "/ThankyouSubscription"
                                        && document.location.pathname !== "/Login" && document.location.pathname !== "/GetPassword" && document.location.pathname !== "/ChangePassword"
                                        && document.location.pathname !== "/CitationSearch" && !document.location.pathname.includes("/Unsubscribe")) {
                                        return (
                                            <Search menuCallback={this.updateParent.bind(this)} AuthorName={this.state.authorName} ref={this.Searchchild} />
                                        )
                                    }
                                }
                                )()}
                                {(() => {
                                    if (document.location.pathname == "/") {
                                        return (
                                            <div className="margn">
                                                <div className="left-half">
                                                    <h1 className="left-halfHeading ">Welcome to Kluwer Law Online </h1>
                                                    {<span style={{ fontSize: '18px' }} dangerouslySetInnerHTML={{ __html: this.state.marketingText }} />}
                                                </div>
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div></div>
                                        )
                                    }

                                }
                                )()}
                            </div>
                            <div style={{ backgroundColor: '#F6F6F6', height: '8px' }}>
                            </div>
                        </div>
                        :
                        null
                    }


                </div>

            </div>



        );

    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.jsx